export const Paths = {
  ROOT: "Home",
  ABOUT: "about",
  TESLA: "tesla-clone",
  TRAINER: "personal-trainer",
  LINKEDIN: "linkedin",
};
